import { ReactNode } from "react";
import SnapSectionsContainer from "@/app/features/shared/snap-section/SnapSectionsContainer";
import Section from "@/app/features/shared/snap-section/Section";

export function CityCuratorArchaeologyScrollSnapFrame({ children }: { children: ReactNode }) {
    return (
        <SnapSectionsContainer>
            {children}
        </SnapSectionsContainer>
    );
}


export function CityCuratorArchaeologyIntroFrame({ children }: { children: ReactNode }) {
    return (
        <Section className="relative">
            {children}
        </Section>
    );
}


export function CityCuratorArchaeologyDetailFrame({ children }: { children: ReactNode }) {
    return (
        <Section className="relative">
            {children}
        </Section>
    )
}

export function CityCuratorArchaeologyRelatedInfosFrame({ children }: { children: ReactNode }) {
    return (
        <div className="relative">
            {children}
        </div>
    )
}

export function CityCuratorArchaeologyRelatedInfoSectionFrame({ children }: { children: ReactNode }) {
    return (
        <Section className="relative">
            {children}
        </Section>
    )
}
